module.exports = __webpack_public_path__ + "img/kangfu.d55b9bed.png";